module.exports = __webpack_public_path__ + "img/pumpkin.abaa0fb0.gif";